<template>
  <div class="broker-presentation-view">
    <v-row>
      <v-col md="12">
        <presentation-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";

export default {
  components: {
    PresentationTable: () =>
      import("@/components/presentation/PresentationTable.vue")
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>
